// extracted by mini-css-extract-plugin
export var wordContainer = "_sb-0";